import axios from "axios";

import { API_BASE_URL } from "../constants";

export default class OtherAssetsAttachmentsService {
    static instance;

    static getInstance() {
        if (!OtherAssetsAttachmentsService.instance) {
            OtherAssetsAttachmentsService.instance = new OtherAssetsAttachmentsService();
        }

        return OtherAssetsAttachmentsService.instance;
    }

    async list(assetId, filters) {
        const response = await axios.get(`${API_BASE_URL}/other_asset/${assetId}/documents`, {
            params: filters,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data || [];
    }

    async addAttachment(assetId, payload = {}){
        const response = await axios.post(`${API_BASE_URL}/other_asset/${assetId}/add_attachment`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                'Content-Type': 'multipart/form-data'
            }
        });
  
        return response.data.data;
    }

    async deleteAttachment(id){
        const response = await axios.delete(`${API_BASE_URL}/other_asset/attachment/${id}/delete_attachment`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
  
        return response.data.data;
    }
}
